import { createReducer } from '@reduxjs/toolkit';
import { ICommonState } from 'app/interfaces/reducer-interface/common.interface';
import { ITableItem } from 'app/interfaces/table-item/table-item.interface';
import {
	getTransactionHistoryListAction,
	setTransactionHistoryListAction,
} from '../actions/TransactionHistoryAction';
import { IPagination } from './PortofolioReducer';

export interface TransactionHistoryListItem extends ITableItem {
	id: string;
	createdDate: number;
	responseDate: number;
	amount: number;
	image: string;
	typeName: string;
	typeId: number;
	status: string;
	userId: string;
	transactionNumber?: string;
	loanNumber: string;
	accountName: string;
	accountNumber: string;
	senderAccountName: string;
	senderAccountNumber: string;
}

export interface TransactionHistoryListState extends ICommonState {
	transactionHistoryList: TransactionHistoryListItem[];
	pagination: IPagination;
}

const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1,
};

const transactionHistory: TransactionHistoryListItem[] = [];

const initialState: TransactionHistoryListState = {
	loading: true,
	transactionHistoryList: transactionHistory,
	pagination: paginationInit,
	error: '',
	message: '',
};

const transactionHistoryReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(getTransactionHistoryListAction, (state) => ({
			...state,
			loading: true,
		}))
		.addCase(setTransactionHistoryListAction, (state, action) => ({
			...state,
			loading: false,
			transactionHistoryList: action.payload.transactionHistoryList,
			pagination: action.payload.pagination,
		}))
		.addDefaultCase((state) => ({
			...state,
		}));
});

// const transactionHistoryReducer = (
// 	action: TransactionHistoryAction,
// 	state = initialState
// ): TransactionHistoryListState => {
// 	switch (action?.type) {
// 		case GET_TRANSACTION_HISTORY_LIST:
// 			return {
// 				...state,
// 				loading: true,
// 			};
// 		case SET_TRANSACTION_HISTORY_LIST:
// 			return {
// 				...state,
// 				loading: false,
// 				transactionHistoryList: action.transactionHistoryList,
// 				pagination: action.pagination,
// 			};
// 		default:
// 			return {
// 				...state,
// 			};
// 	}
// };

export default transactionHistoryReducer;
